import { FC, useContext } from 'react';
import Card from '../Card/Card';
import common from '../../util/scss/common.module.scss';
import { IconSuccess } from '../../icons/Icons';
import GlobalContext from '../../contexts/GlobalContext';

const LogoutSuccess: FC = () => {
    const { language } = useContext(GlobalContext);

    return (
        <Card>
            <section className={`${common.icon}`} data-testid={'icon-error'}>
                <IconSuccess width={'60'} height={'60'} fillColor={'777982'} />
            </section>
            <header>
                <h1 className={common.pageHeader} data-testid="screen-title">
                    {language.logout.success.header}
                </h1>
            </header>
        </Card>
    );
};

export default LogoutSuccess;
